<app-header></app-header>

<div class="container main-page">
  <div class="container margin-top-70">
    <div class="row">
      <div class="col-md-6 mt-6 mx-auto">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">Author Type</td>
              <td>
                <app-drop-down
                  type="authorType"
                  [settings]="dropdownSettingsBookType"
                  [list]="dropdownListBookType"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="defaultAuthorList"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-6 mt-6 mx-auto">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">Netsuit Id</td>
              <td>
                <app-drop-down
                  type="netsuiteId"
                  [settings]="dropdownSettingsNetsuiteIdType"
                  [list]="netSuiteIDList"
                  (dropDownChanged)="updateSelectedDropDown($event)"
                  [selectedItems]="DefaultNetSuiteIDList"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div>
    <div class="container">
      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
        <button
          [disabled]="showSearchLoading"
          type="submit"
          class="btn btn-pkt btn-primary me-1"
          (click)="search()"
        >
          {{searchBtnText}}
          <i class="bi bi-search ps-1"></i>
          <span
            *ngIf="showSearchLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>

        <button
          type="submit"
          class="btn btn-pkt btn-success"
          (click)="downloadReport()"
        >
          {{downloadBtnText}} <i class="bi bi-download ps-1"></i>
        </button>
        <span
          *ngIf="showDownloadLoading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    </div>

    <div class="container table-responsive">
      <table
        class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
      >
        <thead class="thead-dark">
          <tr>
            <th scope="col" style="width: 15%;">Name</th>
            <th scope="col" style="width: 10%;">Email</th>

            <th scope="col" style="width: 10%;">Product Id</th>
            <th scope="col" style="width: 20%;">Netsuite Id</th>

            <th scope="col" style="width: 20%;">Contracted date</th>
            <th scope="col" style="width: 15%;">Published date</th>
            <th scope="col" style="width: 15%;">Country</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let product of products">
            <tr *ngFor="let author of product.author">
              <td>{{author.name}}</td>
              <td>{{author?.contact[0]?.contact_email[0]?.email_address}}</td>
              <td>{{product.part_number}}</td>
              <td>{{author?.contact[0]?.netsuite_internal_id}}</td>
              <td>{{product?.date.contracted_date}}</td>
              <td>{{product?.date.publishing_date}}</td>
              <td>{{author?.contact[0]?.primary_address_country}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="container">
      <app-pagination
        [maxSize]="maxSize"
        [pageSize]="pageSize"
        [collectionSize]="totalProducts"
        (pageChanged)="updatePageData($event)"
      ></app-pagination>
    </div>
  </div>
</div>
